import { REWARD_OFFERING} from "../../constants";
import { getRedeemUrlWithContext } from "../../utils";
import OnboardingPage from "../../common/components/OnboardingPage";

function StarCarWashTactical2Main() {
  const redeemUrl = getRedeemUrlWithContext("star-car-wash-tactical-2");

  return (
    <>
        <OnboardingPage
          redeemUrl={redeemUrl}
          rewardId={REWARD_OFFERING.starcarwashtactical2}
        />
    </>
  );
}

export default StarCarWashTactical2Main;
